import { StatisticsLayout } from 'views/components';
import { isLocked } from 'shared/utils';
import { patientActions } from 'core/Patient';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
    HEADERS,
    downloadHeaders
} from './fixtures';
import {
    PageController,
    Table
} from 'mol-ui';
import React, { useCallback, useState } from 'react';
import {
    useDispatch,
    useSelector
} from 'hooks';

const AbsenceReportList = () => {

    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { push } = useHistory();

    const [currentFilters, setCurrentFilters] = useState({});
    const [ownFilters, setOwnFilters] = useState({});

    const {
        user
    } = useSelector('account');
    const {
        absenceReportsPage,
        absenceReportsPageLoading,
        absenceReportsDownload,
        absenceReportsDownloading
    } = useSelector('patient');

    const handleOrderChange = useCallback(key => {
        setOwnFilters(current => {
            const { order_by, order_way } = current;
            const newFilters = {
                order_by: key,
                order_way: order_by === key && order_way === 'asc' ? 'desc' : 'asc'
            };
            dispatch(patientActions.getAbsenceReportsPage({
                ...currentFilters,
                ...newFilters
            }));
            return newFilters;
        });
    }, [currentFilters, ownFilters]);

    const onFiltersChange = useCallback(filters => {
        setCurrentFilters(filters);
        dispatch(patientActions.getAbsenceReportsPage({
            ...ownFilters,
            ...filters
        }));
    }, [currentFilters, ownFilters, setCurrentFilters]);

    const actionController = [{
        icon: 'search',
        onClick: ({ id }) => push(`${ t('/ausencias') }/${ id }`)
    }];

    const parsedHeaders = HEADERS.map(header => {
        const { orderKey } = header;
        const { order_by, order_way } = ownFilters;
        return ({
            ...header,
            icon: (orderKey !== order_by || !orderKey) ? undefined : order_way === 'asc' ? 'expand_less' : 'expand_more',
            onClick: !orderKey ? undefined : () => handleOrderChange(orderKey)
        });
    });

    const downloadController = {
        data: absenceReportsDownload,
        downloading: absenceReportsDownloading,
        fileName: t('Ausencias'),
        headers: downloadHeaders,
        onDownload: () => dispatch(patientActions.getAbsenceReportsDownload({ ...currentFilters }))
    };

    const { data } = absenceReportsPage?.getData() ?? { data: [] };

    return (
        <StatisticsLayout
            downloadController={ !isLocked(user, 'download_reports') ? downloadController : undefined }
            filterPatients={ ['area', 'cost_center', 'hr_head', 'patient', 'position', 'workplace'] }
            filterProfessionals={ false }
            filterSpecialties={ false }
            title={ t('Ausencias') }
            onFiltersChange={ onFiltersChange }
        >
            <Table
                config={ parsedHeaders }
                data={ data }
                loading={ absenceReportsPageLoading }
            />
            {
                !absenceReportsPageLoading &&
                <PageController
                    controller={ absenceReportsPage }
                    height="20px"
                />
            }
        </StatisticsLayout>
    );
};

export default AbsenceReportList;
